import React from "react";
import { TextField } from "@material-ui/core";
import { Field, FormikProps, FieldProps } from "formik";
import { Values } from "Tools/Values";
import { IPasswordForm } from "../ChangePasswordForm";
import { observer } from "mobx-react";

interface IProps {
  name: string;
  labelKey: string;
  formikProps: FormikProps<IPasswordForm>;
  onChange?: (event: any, formikProps: FormikProps<IPasswordForm>) => void;
}

@observer
class PasswordField extends React.Component<IProps> {
  render() {
    return (
      <Field
        name={this.props.name}
        render={({ field }: FieldProps) => (
          <TextField
            {...field}
            type="password"
            fullWidth
            autoComplete="off"
            onChange={(event) => this.props.onChange(event, this.props.formikProps)}
            style={{ marginTop: "8px" }}
            label={Values.getLocalizationValue(this.props.labelKey)}
            error={this.props.formikProps.touched[this.props.name] && !!this.props.formikProps.errors[this.props.name]}
            helperText={
              this.props.formikProps.touched[this.props.name] && this.props.formikProps.errors[this.props.name]
            }
          />
        )}
      />
    );
  }
}
export default PasswordField;
